import useOrganizationDetails from "./useOrganizationDetails";

const useIsOrgAddressAdded = () => {
  const orgDetails = useOrganizationDetails();

  return (
    !!orgDetails?.city &&
    (!!orgDetails?.pincode || orgDetails?.pincode === 0) &&
    !!orgDetails?.state &&
    !!orgDetails?.country &&
    !!orgDetails?.country_initials &&
    !!orgDetails?.address_line_1 &&
    !!orgDetails?.address_line_2
  );
};

export default useIsOrgAddressAdded;
